import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import StatusBadge from "../../../components/common/StatusBadge";
import { getMyAssignedTasks } from "../api/workTaskAssignmentApi";

const MyWork = () => {
  const navigate = useNavigate();

  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTasks();
  }, []);

  const loadTasks = async () => {
    try {
      const res = await getMyAssignedTasks();
      setTasks(res.data);
    } catch (err) {
      console.error("Failed to load tasks", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="p-6">Loading...</div>;

  return (
    <div className="space-y-6 p-6">

      <h2 className="text-2xl font-bold">My Work</h2>

      <div className="bg-white rounded-xl shadow overflow-hidden">

        <table className="w-full text-sm">

          <thead className="bg-slate-100 text-slate-600">
            <tr>
              <th className="p-3 text-left">Client</th>
              <th className="p-3 text-left">Assignment</th>
              <th className="p-3 text-left">Task</th>
              <th className="p-3 text-left">Status</th>
              <th className="p-3 text-left">Due</th>
              <th className="p-3 text-right">Action</th>
            </tr>
          </thead>

          <tbody>

            {tasks.length === 0 && (
              <tr>
                <td colSpan="6" className="p-6 text-center text-slate-500">
                  No assigned tasks.
                </td>
              </tr>
            )}

            {tasks.map(task => {

              const isOverdue =
                task.DueDate &&
                new Date(task.DueDate) < new Date() &&
                task.Status !== "Approved";

              return (
                <tr
                  key={task.TaskID}
                  className={`border-t hover:bg-slate-50 ${
                    isOverdue ? "bg-red-50" : ""
                  }`}
                >

                  <td className="p-3 font-semibold">
                    {task.ClientName}
                  </td>

                  <td className="p-3">
                    {task.AssignmentName}
                  </td>

                  <td className="p-3">
                    {task.TaskTitle}
                  </td>

                  <td className="p-3">
                    <StatusBadge status={task.Status} />
                  </td>

                  <td className="p-3">
                    {task.DueDate
                      ? new Date(task.DueDate).toLocaleDateString()
                      : "-"}
                  </td>

                  <td className="p-3 text-right">
                    <button
                      onClick={() =>
                        navigate(`/tasks/work/${task.WorkID}/areas`)
                      }
                      className="text-indigo-600 font-semibold hover:underline"
                    >
                      Open Workspace
                    </button>
                  </td>

                </tr>
              );
            })}

          </tbody>

        </table>

      </div>

    </div>
  );
};

export default MyWork;